(function () {
  const KEY = "aerolab_preorder_v1";

  function load() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch (e) {
      return [];
    }
  }

  function save(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
  }

  function add(item) {
    const items = load();
    const idx = items.findIndex((x) => x.variantId === item.variantId);
    if (idx >= 0) {
      items[idx].qty = Math.min(999, (items[idx].qty || 1) + (item.qty || 1));
    } else {
      items.push({
        productTitle: item.productTitle,
        variantTitle: item.variantTitle,
        productHandle: item.productHandle,
        productUrl: item.productUrl,
        variantId: item.variantId,
        sku: item.sku || "",
        vendor: item.vendor || "",
        qty: item.qty || 1,
      });
    }
    save(items);
    return items;
  }

  function remove(variantId) {
    const items = load().filter((x) => x.variantId !== variantId);
    save(items);
    return items;
  }

  function updateQty(variantId, qty) {
    const q = Math.max(1, Math.min(999, parseInt(qty, 10) || 1));
    const items = load().map((x) => (x.variantId === variantId ? { ...x, qty: q } : x));
    save(items);
    return items;
  }

  function clear() {
    save([]);
    return [];
  }

  function count() {
    return load().reduce((sum, x) => sum + (x.qty || 1), 0);
  }

  function formatMessage(items) {
    const lines = [];
    lines.push("Vorbestellung (Anfrage) – Aktion 2026");
    lines.push("");
    items.forEach((x, i) => {
      const name = x.productTitle + (x.variantTitle ? " – " + x.variantTitle : "");
      const sku = x.sku ? ` | SKU: ${x.sku}` : "";
      const url = x.productUrl ? ` | Link: ${x.productUrl}` : "";
      lines.push(`${i + 1}. ${name} | Menge: ${x.qty}${sku}${url}`);
    });
    lines.push("");
    lines.push("Hinweis: Lieferzeit ca. 1–3 Wochen, Lieferbarkeit & Mindestmenge vorausgesetzt.");
    return lines.join("\n");
  }

  // Expose minimal API
  window.AerolabPreorder = {
    load,
    add,
    remove,
    updateQty,
    clear,
    count,
    formatMessage,
  };

  // Button handler
  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-aerolab-preorder-add]");
    if (!btn) return;

    e.preventDefault();

    const payload = {
      productTitle: btn.getAttribute("data-product-title") || "",
      variantTitle: btn.getAttribute("data-variant-title") || "",
      productHandle: btn.getAttribute("data-product-handle") || "",
      productUrl: btn.getAttribute("data-product-url") || "",
      variantId: parseInt(btn.getAttribute("data-variant-id") || "0", 10),
      sku: btn.getAttribute("data-sku") || "",
      vendor: btn.getAttribute("data-vendor") || "",
      qty: 1,
    };

    if (!payload.variantId) return;

    const items = add(payload);

    // Simple feedback
    btn.classList.add("is-added");
    const old = btn.textContent;
    btn.textContent = "Hinzugefügt ✓";
    setTimeout(() => {
      btn.textContent = old;
      btn.classList.remove("is-added");
    }, 1200);

    // Update any badge
    document.querySelectorAll("[data-aerolab-preorder-count]").forEach((el) => {
      el.textContent = String(count());
    });

    // Optional: open drawer/page
    const go = btn.getAttribute("data-go-to");
    if (go === "page") {
      window.location.href = "/pages/vorbestellung";
    }
  });

  // Init badges
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-aerolab-preorder-count]").forEach((el) => {
      el.textContent = String(count());
    });
  });
})();
